import { clearApplicationState } from "@app/state/cleanup";
import { useAuth0 } from "@auth0/auth0-react";
import { useEffect } from "react";

export default function LogoutRoute() {
  const { logout } = useAuth0();

  async function doLogout() {
    // Clear all application state before logout
    await clearApplicationState();

    await logout({
      logoutParams: { returnTo: window.location.origin, federated: true }
    });
  }

  useEffect(() => {
    void doLogout();
  }, []);

  return undefined;
}
